import { createStackNavigator } from '@react-navigation/stack'
import { BackComp } from '../../comps/CustomHeader/BackComp'
import { titleCase } from '../../comps/CustomHeader/headerFunctionHelpers'

import ProfileMobile from '../../screens/ProfileMobile'

const NewProfileScreenStackArray = [
  {
    name: 'NewProfile',
    comp: ProfileMobile,
    title: '',
    showHeader: false,
  },
]

const Stack = createStackNavigator()

const ProfileScreenStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerBackTitleVisible: false, headerMode: 'screen' }}>
      {NewProfileScreenStackArray?.map((item) => {
        return (
          <Stack.Screen
            key={item?.name}
            name={item?.name}
            component={item?.comp}
            options={{
              headerShown: false,
              headerLeft: () => (item?.showHeader === false ? undefined : <BackComp />),
              title: titleCase(item?.title ?? undefined),
            }}
          />
        )
      })}
    </Stack.Navigator>
  )
}

export default ProfileScreenStack
